import React from "react";
import { Route, Switch } from "react-router-dom";

import { QUOTATION } from "constants/routes";

import { Admins } from "constants/userRoles";

import QuotationIndex from "views/Quotation/QuotationIndex";
import QuotationCreate from "views/Quotation/QuotationCreate";
import QuotationDetail from "views/Quotation/QuotationDetail";
import QuotationEdit from "views/Quotation/QuotationEdit";
import ConvertQuotationToAgreement from "views/Quotation/ConvertQuotationToAgreement";

const QuotationRoutes = () => (
  <Switch>
    <Route exact path={QUOTATION.INDEX} component={Admins(QuotationIndex)} />
    <Route exact path={QUOTATION.CREATE} component={Admins(QuotationCreate)} />
    <Route exact path={QUOTATION.SHOW} component={Admins(QuotationDetail)} />
    <Route exact path={QUOTATION.EDIT} component={Admins(QuotationEdit)} />
    <Route
      exact
      path={QUOTATION.CONVERT_TO_AGREEMENT}
      component={Admins(ConvertQuotationToAgreement)}
    />
  </Switch>
);

export default QuotationRoutes;
